function ListBlock({ title, items, emptyText }) {
  return (
    <div className="deadline-warning-block">
      <h4>{title}</h4>
      {items.length ? (
        <ul className="deadline-result-list">
          {items.map((item, index) => <li key={`${title}-${index}`}>{item}</li>)}
        </ul>
      ) : (
        <p>{emptyText}</p>
      )}
    </div>
  )
}

function formatIgnoredRule(rule) {
  if (typeof rule === 'string') return rule
  const code = rule.ruleCode || rule.code || 'Regra sem código'
  const reason = rule.reason || rule.description || 'Motivo não informado'
  return `${code}: ${reason}`
}

function formatConflict(conflict) {
  if (typeof conflict === 'string') return conflict
  return Object.entries(conflict || {})
    .map(([key, value]) => `${key}: ${value}`)
    .join(' | ') || 'Conflito sem detalhes'
}

export default function DeadlineWarningsCard({ warnings = [], ignoredRules = [], conflicts = [] }) {
  const formattedIgnoredRules = ignoredRules.map(formatIgnoredRule)
  const formattedConflicts = conflicts.map(formatConflict)

  return (
    <section className="rules-card deadline-result-section">
      <div className="rules-card-header">
        <div>
          <h3>Warnings, regras ignoradas e conflitos</h3>
          <p>Pontos de atenção para revisão humana ou ajustes de regra.</p>
        </div>
      </div>
      <div className="rules-card-body deadline-warning-grid">
        <ListBlock title="Warnings" items={warnings} emptyText="Nenhum warning retornado." />
        <ListBlock title="Regras ignoradas" items={formattedIgnoredRules} emptyText="Nenhuma regra ignorada informada." />
        <ListBlock title="Conflitos" items={formattedConflicts} emptyText="Nenhum conflito informado." />
      </div>
    </section>
  )
}
